import React, { useMemo, useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import ReportsTable from "./ReportsTable";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import NotFound from "../../Alerts/NotFound";
import { useOktaAuth } from "@okta/okta-react";


const useStyles = makeStyles({
  root: {
    height: "30px",
    color: "rgb(8,87,97)",
  },
  text: {
    marginLeft: "-20px",
    fontWeight: "bold",
    fontSize: "30px",
  },
  icon: {
    color: "rgb(8,87,97)",
    marginLeft: "-10px",
  },
});

export default function Reports() {
  const [data, setData] = useState([]);
  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState("");
  const classes = useStyles();

  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      setUserInfo(null);
    } else {
      oktaAuth.getUser().then((info) => {
        setUserInfo(info.groups);
      });
    }
  }, [authState, oktaAuth]);

  const getData = () => {
    (async () => {
      const result = await fetch("reportsTestData.json", {
        method: "GET",
        headers: {
          // Authorization:'weoifjg0924gjwgj',
          "Content-Type": "application/json",
        },
      });
      const names = await result.json();
      setData(names);
    })();
  };
  const updateTime = () => {
    var current = new Date();
    return current.toLocaleString();
  };

  useEffect(() => {
    getData();
    const interval = setInterval(() => {
      getData();
      updateTime();
    }, 100000);
    return () => clearInterval(interval);
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "EUID",
        accessor: "Euid",
      },
      {
        Header: "First Name",
        accessor: "FirstName",
      },
      {
        Header: "Last Name",
        accessor: "LastName",
      },
      {
        Header: "DOB",
        accessor: "BirthDate",
      },
      {
        Header: "Gender",
        accessor: "Gender",
      },
      {
        Header: "Ethnicity",
        accessor: "Ethnicity",
      },
      {
        Header: "Race",
        accessor: "Race",
      },
      {
        Header: "Phone",
        accessor: "Phone",
      },
      {
        Header: " Address",
        accessor: "Address",
      },
      {
        Header: "Zipcode",
        accessor: "Zipcode",
      },
      {
        Header: "City",
        accessor: "City",
      },
      {
        Header: "County",
        accessor: "County",
      },
      {
        Header: "State",
        accessor: "State",
      },
      {
        Header: "Death Flag",
        accessor: "DeathFlag",
      },
      {
        Header: "Result Date",
        accessor: "ResultDate",
      },
      {
        Header: "Recovered",
        accessor: "Recovered",
      },
      {
        Header: "Ventilator Access(Closest)",
        accessor: "VentilatorAccess",
      },
      {
        Header: "Chronic Conditions",
        accessor: "ChronicConditions",
      },
      {
        Header: "Local Health District",
        accessor: "LocalHealthDistrict",
      },
      {
        Header: "Active Hospitalization",
        accessor: "ActiveHospitalization",
      },
      {
        Header: "Hospitalization",
        accessor: "Hospitalization",
      },
      {
        Header: "ICU Admit",
        accessor: "IcuAdmit",
      },
      {
        Header: "Hospital",
        accessor: "Hospital",
      },
      {
        Header: "Admit Date",
        accessor: "AdmitDate",
      },
      {
        Header: "Discharge Date",
        accessor: "DischargeDate",
      },
      {
        Header: "Ventilator",
        accessor: "Ventilator",
      },
      {
        Header: "Ventilator Start Date",
        accessor: "VentilatorStartDate",
      },
      {
        Header: "Ventilator End Date",
        accessor: "VentilatorEndDate",
      },
      {
        Header: "ECMO",
        accessor: "Ecmo",
      },
      {
        Header: "Remdesivir",
        accessor: "Remdesivir",
      },
      {
        Header: "Provider First Name",
        accessor: "ProviderFirstName",
      },
      {
        Header: "Provider LastName",
        accessor: "ProviderLastName",
      },
      {
        Header: "Discharge Disposition",
        accessor: "DischargeDisposition",
      },
      {
        Header: "Pneumonia",
        accessor: "Pneumonia",
      },
      {
        Header: "Fever",
        accessor: "Fever",
      },
      {
        Header: "Cough",
        accessor: "Cough",
      },
      {
        Header: "Shortness of Breath",
        accessor: "ShortnessOfBreath",
      },
    ],
    []
  );

  const handleGroupAuth = (str) => {
    return userInfo && userInfo.indexOf(str) !== -1;
  };

  if (handleGroupAuth("Nebraska Reports Dashboard Users")) {
  return (
    <div>
      <div className="mt-5 pt-4">
        <ListItem className={classes.root}>
          <ListItemIcon>
            <EqualizerIcon fontSize="large" className={classes.icon} />
          </ListItemIcon>
          <ListItemText disableTypography>
            <span className={classes.text}>Reports</span>
            <div className="d-inline">
              <span className=" ml-3"> Last Updated : {updateTime()}</span>
            </div>
          </ListItemText>
        </ListItem>
      </div>
      <Paper elevation={2} style={{ padding: "8px", marginTop: "25px" }}>
        <ReportsTable columns={columns} data={data} />
      </Paper>
      <div className="alert alert-light mt-4" role="alert">
        Disclaimer: Disclosure of identifiable health information is made
        pursuant to Nebraska Executive Order No. 20-15 and the federal HHS
        <a href="https://www.hhs.gov/sites/default/files/notification-enforcement-discretion-hipaa.pdf?language=es">
          Notification of Enforcement Discretion under HIPAA
        </a>
        , as such use is made to individuals who are in a position to prevent
        and lessen a serious and imminent threat to the health and safety of a
        person or the public.
      </div>
    </div>
  )} else {
    return (<NotFound/>);
  }
}
